/* マイページ開設同意確認画面 */
import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import axios from '../axios';
import HtmlParser from '../molecules/HtmlParser';
import { Form } from 'react-bootstrap';
import Block from '../molecules/Block';
import LoadingModal from '../molecules/LoadingModal';
import { jumpUrl } from '../Common';
import { Agreement, OutputRequestDetails, PostData, ResponseData } from '../types/MypageAgreement';
import { module_name, api_response_type } from '../Const';
import { handleBrowzerBack } from '../BrowzerBack';

const MypageAgreement: React.FC = () => {
  const [agreements, setAgreements] = useState<Array<Agreement>>([]);
  const [logined, setLogined] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();

    const getAgreement = async () => {
      try {
        setShow(true);
        const response = await axios.get('/agreement/guarantor');
        setAgreements(response.data.agreements);
        setLogined(response.data.logined);
      } catch (error) {
        console.error(error);
      } finally {
        setShow(false);
      }
    };
    getAgreement();
  }, []);

  /**
   * 各同意文の同意状態を変更する
   *
   * @param event イベント
   */
  const handleClickAgreementButton = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const name = event.currentTarget.name;
    setAgreements((prev) =>
      prev.map((value) =>
        value.id === name
          ? {
              ...value,
              button_checked: true,
            }
          : value
      )
    );
  };

  /**
   * 各同意文チェックボックスのチェックを変更する
   *
   * @param event イベント
   * @return void
   */
  const handleChangeAgreementCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.currentTarget.name;
    setAgreements((prev) =>
      prev.map((value) =>
        value.id === name
          ? {
              ...value,
              checkbox_checked: !value.checkbox_checked,
            }
          : value
      )
    );
  };

  /**
   * 同意条件を確認する
   *
   * @returns boolean
   */
  const disabledNext = (): boolean => {
    return agreements.some((agreement) => agreement.button_checked === false);
  };

  /**
   * APIへリクエストを送る
   * @param details
   */
  const requestOutput = async (details: OutputRequestDetails[]) => {
    try {
      setShow(true);
      const post_data: PostData = {
        module_name: module_name.mypage_check,
        is_json: true,
        detail: details,
      };
      // APIにデータをPOSTする
      const api_route = logined ? '/api/common' : '/api/common/unauth';
      const response = await axios.post(api_route, post_data);
      allocationResponseData(response.data);
    } catch (exception) {
      console.error(exception);
      jumpUrl(exception.response.data.url);
    } finally {
      setShow(false);
    }
  };

  /**
   * APIへリクエストを送るオブジェクトを生成
   */
  const handleClickNext = async () => {
    const details = agreements.map((agreement) => {
      return {
        id: agreement.id,
        checked: agreement.checkbox_checked,
      };
    });
    requestOutput(details);
  };

  /**
   * レスポンス値を元に処理を振り分ける
   *
   * @param {ResponseData} response_data レスポンスデータ
   */
  const allocationResponseData = (response_data: ResponseData) => {
    //switch文いらない？ 今後拡張機能（種別で分かれる）があるかもしれないので一応付けました tanaka
    switch (response_data.response_type) {
      case api_response_type.page_transition: // 画面遷移
        pageTransition(response_data.reception_cd, response_data.reception_id);
        break;
      default:
        break;
    }
  };

  /**
   * レスポンスで返された値を利用して、次の詳細画面を表示します。
   * @param reception_cd 案件コード
   * @param reception_id 案件id
   */
  const pageTransition = (reception_cd: string, reception_id: number) => {
    setShow(false);
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${reception_id}`;
  };

  return (
    <div id="mypage-agreement">
      <div>
        <h4 className="font-weight-bold">同意書</h4>
      </div>
      <div>
        {agreements.map((agreement, index) => {
          return (
            <div key={index}>
              <Block label={agreement.title} content={<HtmlParser html={agreement.text} />} />
              <div className="block mx-auto col-xs-11 col-sm-11 col-md-8 col-11 px-0 text-start">
                <button
                  className="btn btn-main-color"
                  name={agreement.id}
                  disabled={agreement.button_checked}
                  onClick={handleClickAgreementButton}
                >
                  同意する
                </button>
              </div>
              {agreement.check_box_title && (
                <>
                  <br></br>
                  <label className="check-box-label">
                    <Form.Check
                      type="checkbox"
                      inline
                      name={agreement.id}
                      checked={agreement.checkbox_checked}
                      onChange={handleChangeAgreementCheck}
                      className="check-box"
                    />
                    {agreement.check_box_title}
                  </label>
                </>
              )}
            </div>
          );
        })}
      </div>
      <div>
        <a href="https://www.himegin.co.jp/personal/loan/housing/web_house/home_loan.html">
          「反社会的勢力に関する表明・確約条項」「マイページ利用規約」「個人情報の取扱いに関する同意事項は、愛媛銀行ホームページ」
        </a>
      </div>
      <button className="btn btn-main-color" disabled={disabledNext()} onClick={handleClickNext}>
        次へ
      </button>
      <LoadingModal show={show} />
    </div>
  );
};

const container = document.getElementById('mypage-agreement');
if (container) {
  const root = createRoot(container);
  root.render(<MypageAgreement />);
}
